import React, { FC } from "react";
import '../../styles/components/meetingRound.scss';

interface MeetingRoundProps {
  color: string;
}

export const MeetingRound: FC<MeetingRoundProps> = ({ color }) => {
  return (
    <div style={{ backgroundColor: color }} className="meeting-round"/>
  )
}